import React from 'react';
import { Banner, Button, Flex, FlexItem } from '@patternfly/react-core';
import { TimesIcon, UserIcon } from '@patternfly/react-icons';
import { useImpersonation } from '../../contexts/impersonation/ImpersonationContext';
import { useImpersonationWithNotifications } from '../../contexts/impersonation/useImpersonationWithNotifications';

/**
 * Persistent banner shown at the top of every authenticated page when
 * client impersonation is active. Renders nothing when not impersonating.
 *
 * The banner sits in the Page chrome (not inside the routed content), so
 * it is always visible regardless of which page the operator is on, and
 * it does not scroll with the page body.
 */
export const ImpersonationBanner: React.FC = () => {
  const { target, isImpersonating } = useImpersonation();
  const { stopWithNotification } = useImpersonationWithNotifications();

  if (!isImpersonating || target === null) {
    return null;
  }

  return (
    <Banner status="warning" isSticky screenReaderText="Warning banner: client impersonation is active">
      <Flex justifyContent={{ default: 'justifyContentSpaceBetween' }} alignItems={{ default: 'alignItemsCenter' }}>
        <FlexItem>
          <UserIcon className="pf-v6-u-mr-sm" aria-hidden />
          Acting as: <strong>{target.name}</strong>
          {target.netbox_owner_name && (
            <span className="pf-v6-u-ml-xs pf-v6-u-color-200">({target.netbox_owner_name})</span>
          )}
        </FlexItem>
        <FlexItem>
          <Button variant="danger" size="sm" icon={<TimesIcon />} onClick={stopWithNotification}>
            Stop impersonation
          </Button>
        </FlexItem>
      </Flex>
    </Banner>
  );
};
